<div class="assistant-knowledge-wrapper">
  <div class="wrapper">
    <div class="assistant-sub-header"><div class="title">Knowledge</div></div>
    <div class="assistant-knowledge-container">
      <div class="assistant-knowledge">
        <div class="knowledge-title-container">
          <span class="knowledge-description">{{ ASSISTANT_KNOWLEDGE_CONTENT.knowledgeBase.title }}</span>
          <span *ngIf="!assistantId" class="mandatory-fields">*</span>
        </div>
        <u-dropdown
          class="options-elements"
          [options]="assistantsKnowledgeOptions()?.knowledgeBase"
          [selectedValue]="selectedKnowledgeType()"
          optionLabel="label"
          optionalSubLabel="subLabel"
          dropdownSize="large"
          placeholder="Select"
          (onChange)="onDropDownChanged($event, 'knowledgeType')"
          [styles]="{ width: '320px', height: '32px' }"
          [readonly]="!!assistantId && this.selectedKnowledgeType()"
        >
        </u-dropdown>
        <span *ngIf="!assistantId && this.selectedKnowledgeType()" class="indication"
          >This section cannot be changed after it has been saved</span
        >
      </div>
      @if (!disableExternalChat && selectedKnowledgeType()?.value === 'External') {
        <div class="assistant-knowledge">
          <div class="knowledge-title-container">
            <span class="knowledge-description">{{ ASSISTANT_KNOWLEDGE_CONTENT.baseAIModelBase.title }}</span>
            <span *ngIf="!assistantId" class="mandatory-fields">*</span>
          </div>
          <u-dropdown
            *ngIf="baseAIModel()"
            class="options-elements"
            [options]="baseAIModel()"
            [selectedValue]="selectedBaseAIModelOption()"
            [dropdownSelectIcon]="selectedBaseAIModelOption()?.icon"
            optionLabel="label"
            optionalSubLabel="subLabel"
            optionDisabled="subLabel"
            dropdownSize="large"
            placeholder="Select"
            (onChange)="onDropDownChanged($event, 'llm')"
            [styles]="{ width: '320px', height: '32px' }"
            [readonly]="isViewer || selectedKnowledgeType()?.value === 'Internal' || !!assistantId"
            [iconInnerSvg]="true"
          >
          </u-dropdown>
        </div>
      }
    </div>
  </div>
  @if (showTools()) {
    <div class="wrapper tools">
      <div class="assistant-sub-header">
        <div class="title">Tools</div>
      </div>
      <ng-container
        *ngTemplateOutlet="
          toolTemplate;
          context: {
            tool: 'fileSearch',
            text: ASSISTANT_KNOWLEDGE_CONTENT.tools.allowFileUpload,
            tooltip: ASSISTANT_KNOWLEDGE_CONTENT.tools.allowFileUploadTooltip,
            disabled: !showFileSearch(),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          toolTemplate;
          context: {
            tool: 'webSearch',
            text: ASSISTANT_KNOWLEDGE_CONTENT.tools.allowWebAccess,
            tooltip: ASSISTANT_KNOWLEDGE_CONTENT.tools.allowWebAccessTooltip,
            disabled: !showWebSearch(),
          }
        "
      ></ng-container>
    </div>
  }
</div>

<ng-template #toolTemplate let-text="text" , let-tooltip="tooltip" , let-tool="tool" , let-disabled="disabled">
  <div class="check-line">
    <div class="label">
      {{ text }}
      <u-icon
        [model]="{ type: 'font', value: 'icon-info' }"
        [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
        [pTooltip]="tooltip"
        tooltipPosition="bottom"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
    </div>
    <u-toggle-switch
      [type]="'small'"
      [disabled]="isViewer || disabled"
      [(checked)]="assistantProperties().experienceTools[tool].enabled"
      (onChange)="onChangeTools()"
      [pTooltip]="disabled ? ASSISTANT_KNOWLEDGE_CONTENT.tools.disabledTooltip : null"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    ></u-toggle-switch>
  </div>
</ng-template>
